import { render, staticRenderFns } from "./InvoicePreviewPdfDocument.vue?vue&type=template&id=133a1837&scoped=true"
import script from "./InvoicePreviewPdfDocument.vue?vue&type=script&lang=ts"
export * from "./InvoicePreviewPdfDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133a1837",
  null
  
)

export default component.exports